export default "__VITE_ASSET__CLVLjJg$__"